import { createContext } from "react";

type TabsContextType<TValue extends string | number = any> = {
  vertical: boolean;
  activeValue?: TValue;
  setActiveValue: (value: TValue) => void;
};

export const TabsContext = createContext({} as TabsContextType);
